export const STORAGE_PREFIX =
    "c24-" + process.env.REACT_APP_PLATFORM + "-item_";

export default {
    STORAGE_PREFIX,
};
